import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import { StationType } from "Types/station";

interface IStationsFilter {
  q?: string;
  type?: StationType | "";
}
interface IPathsFilter {
  q?: string;
  type?: StationType[] | [];
}
interface ISurveysFilter {
  [key: string]: any;
}
interface IState {
  visibility: string[];
  conformity: { source: boolean; destination: boolean };
  stations: IStationsFilter;
  paths: IPathsFilter;
  surveys: ISurveysFilter;
  date: any;
}

const initialState: IState = {
  visibility: [],
  conformity: { source: true, destination: true },
  stations: { q: "", type: "" },
  paths: { q: "", type: [] },
  surveys: {},
  date: {},
};

export const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    toggleVisibility: (state, action: PayloadAction<string>) => {
      if (state.visibility.includes(action.payload)) {
        return { ...state, visibility: state.visibility.filter((i) => i !== action.payload) };
      }
      return { ...state, visibility: [...state.visibility, action.payload] };
    },
    changeConformity: (state, action: PayloadAction<"source" | "destination">) => {
      const currentData = state.conformity;

      if (action.payload === "source") return { ...state, conformity: { ...currentData, source: !currentData.source } };
      return { ...state, conformity: { ...currentData, destination: !currentData.destination } };
    },
    changeStationsFilter: (state, action: PayloadAction<IStationsFilter>) => {
      return { ...state, stations: { ...state.stations, ...action.payload } };
    },
    changePathsFilter: (state, action: PayloadAction<IPathsFilter>) => {
      return { ...state, paths: { ...state.paths, ...action.payload } };
    },
    changeSurveysFilter: (state, action: PayloadAction<ISurveysFilter>) => {
      return { ...state, surveys: { ...state.surveys, ...action.payload } };
    },
    changeDate: (state, action: PayloadAction<any>) => {
      return { ...state, date: { ...state.date, ...action.payload } };
    },
    clearSurveysFilter: (state, action: PayloadAction<any>) => {
      return { ...state, surveys: action.payload };
    },
    makeInvisible: (state) => {
      return { ...state, visibility: [] };
    },
  },
});

export const {
  toggleVisibility,
  changeConformity,
  changeStationsFilter,
  changePathsFilter,
  changeSurveysFilter,
  clearSurveysFilter,
  makeInvisible,
  changeDate,
} = filtersSlice.actions;

export default filtersSlice.reducer;
